export const SET_SUBMITTED_ANSWERED_PATIENT_CPP = 'CPPGlobalContext.SET_SUBMITTED_ANSWERED_PATIENT_CPP';
export const SET_RESOLVED_ANSWERED_PATIENT_CPP = 'CPPGlobalContext.SET_RESOLVED_ANSWERED_PATIENT_CPP';
export const SET_ALL_CPP = 'CPPGlobalContext.SET_ALL_CPP';
export const SET_CPP_NOTES = 'CPPGlobalContext.SET_CPP_NOTES';